// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1jp1i","textarea":"styles_textarea__SQY9h"};